import React from "react";
import { Field, ErrorMessage } from "formik";

import ErrorTextMessage from "../errorTextMessage/ErrorTextMessage";

//-------TextareaField component start here
const TextareaField = (props) => {
  const {
    name,
    rows,
    label,
    placeHolder,
    maxLength = 500,
    labelClassName,
    isDoubleHeight = false,
    onBlur,
  } = props;

  //-------Return TextareaField Component
  return (
    <div>
      <label className={`field-label ${labelClassName}`} htmlFor={name}>
        {label && label}
      </label>
      <div className="textarea-field-wrapper">
        <Field
          className={`input-textfield text-area-field 
            ${isDoubleHeight ? "text-area-double-height" : ""}
          `}
          id={name}
          name={name}
          rows={rows}
          as="textarea"
          autoComplete="off"
          maxLength={maxLength}
          placeholder={placeHolder}
          onBlur={onBlur}
        />
      </div>
      <ErrorMessage name={name} component={ErrorTextMessage} />
    </div>
  ); //-------TextareaField component end here
};

//-------Export InputTextField Component
export default TextareaField;
